import {
  ComparisonParams,
  DependenciesParams,
  EnumParams,
  ErrorObject,
  ErrorParameters,
  FormatParams,
  LimitParams,
  PatternParams,
  RequiredParams,
  UniqueItemsParams,
} from 'ajv';

import {
  CustomError,
  DependencyError,
  EnumError,
  FormatError,
  MaximumError,
  MaxItemsError,
  MaxLengthError,
  MinimumError,
  MinItemsError,
  MinLengthError,
  PatternError,
  RequiredError,
  UniqueItemsError,
} from './types/ValidationError';

export function isRequiredError(error: ErrorObject): error is RequiredError {
  return error.keyword === 'required' && isRequiredParams(error.params);
}

export function isDependencyError(error: ErrorObject): error is DependencyError {
  return error.keyword === 'dependencies' && isDependenciesParams(error.params);
}

export function isFormatError(error: ErrorObject): error is FormatError {
  return error.keyword === 'format' && isFormatParams(error.params);
}

export function isMinimumError(error: ErrorObject): error is MinimumError {
  return error.keyword === 'minimum' && isComparisonParams(error.params);
}

export function isMaximumError(error: ErrorObject): error is MaximumError {
  return error.keyword === 'maximum' && isComparisonParams(error.params);
}

export function isMinLengthError(error: ErrorObject): error is MinLengthError {
  return error.keyword === 'minLength' && isLimitParams(error.params);
}

export function isMaxLengthError(error: ErrorObject): error is MaxLengthError {
  return error.keyword === 'maxLength' && isLimitParams(error.params);
}

export function isMinItemsError(error: ErrorObject): error is MinItemsError {
  return error.keyword === 'minItems' && isLimitParams(error.params);
}

export function isMaxItemsError(error: ErrorObject): error is MaxItemsError {
  return error.keyword === 'maxItems' && isLimitParams(error.params);
}

export function isCustomError(error: ErrorObject): error is CustomError {
  return error.keyword === 'errorMessage';
}

export function isEnumError(error: ErrorObject): error is EnumError {
  return error.keyword === 'enum' && isEnumParams(error.params);
}

export function isUniqueError(error: ErrorObject): error is UniqueItemsError {
  return error.keyword === 'uniqueItems' && isUniqueParams(error.params);
}

export function isPatternError(error: ErrorObject): error is PatternError {
  return error.keyword === 'pattern' && isPatternParams(error.params);
}

function isRequiredParams(value: ErrorParameters): value is RequiredParams {
  return (value as RequiredParams).missingProperty !== undefined;
}

function isDependenciesParams(value: ErrorParameters): value is DependenciesParams {
  const params = value as DependenciesParams;
  return params.missingProperty !== undefined && params.property !== undefined;
}

function isFormatParams(value: ErrorParameters): value is FormatParams {
  return (value as FormatParams).format !== undefined;
}

function isEnumParams(value: ErrorParameters): value is EnumParams {
  return (value as EnumParams).allowedValues !== undefined;
}

function isComparisonParams(value: ErrorParameters): value is ComparisonParams {
  return (value as ComparisonParams).comparison !== undefined;
}

function isLimitParams(value: ErrorParameters): value is LimitParams {
  return (value as LimitParams).limit !== undefined;
}

function isUniqueParams(value: ErrorParameters): value is UniqueItemsParams {
  return (value as UniqueItemsParams).i !== undefined && (value as UniqueItemsParams).j !== undefined;
}

function isPatternParams(value: ErrorParameters): value is PatternParams {
  return (value as PatternParams).pattern !== undefined;
}
